export default __webpack_public_path__ + "static/media/back.32028a85.jpg";